import {findSectionByLabel} from '../data/sections';
import type {Article} from '../types/article';

const routeSlug = (value: string): string => value.trim().toLowerCase()
  .normalize('NFKD')
  .replace(/[^a-z0-9]+/gu, '-')
  .replace(/^-|-$/gu, '');

export const articlePath = (article: Article): string => {
  const section = findSectionByLabel(article.section)?.slug ?? routeSlug(article.section);
  return `/${section}/${encodeURIComponent(article.slug)}`;
};
